import {I18n} from 'aws-amplify/utils';

import {
    COMPANY_NAME,
    PRODUCT_NAME
} from './product';

/**
 * TRANSLATE A STRING, THEN PUT THE PRODUCT NAME IN IT.
 *
 * ⚠️ WHY NOT JUST INTERPOLATE INTO `I18n.get()` DIRECTLY.
 *
 * `I18n.get()` looks a translation up BY ITS ENGLISH TEXT — the string is the
 * key. Building that key with a template literal would make the lookup key
 * depend on a runtime value, so a rename would silently orphan every
 * translation of every affected string, and the dictionary would have to be
 * rewritten to match. Keeping `{product}` in the key keeps the key stable
 * whatever the product is called.
 *
 * So the order matters: translate first, substitute second.
 *
 *   productCopy('Thank you for signing up for {product}!')
 *     → I18n.get('Thank you for signing up for {product}!')  ← stable key
 *     → 'Thank you for signing up for Flexi Bot!'             ← what they read
 *
 * `{company}` is substituted too, for the copy where the publisher really is
 * the subject — the corporate paragraphs on the About page. Everything a
 * customer reads about what this application does for them takes `{product}`.
 */
export function productCopy(key: string): string {
    return I18n.get(key)
        .split('{product}').join(PRODUCT_NAME)
        .split('{company}').join(COMPANY_NAME);
}
